import { render, staticRenderFns } from "./SzabadsagElfogadas.vue?vue&type=template&id=1d43cc26&scoped=true&"
import script from "./SzabadsagElfogadas.vue?vue&type=script&lang=js&"
export * from "./SzabadsagElfogadas.vue?vue&type=script&lang=js&"
import style0 from "./SzabadsagElfogadas.vue?vue&type=style&index=0&id=1d43cc26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d43cc26",
  null
  
)

export default component.exports